import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { CiMicrophoneOn } from "react-icons/ci";
import { GiForkKnifeSpoon } from "react-icons/gi";
import { ImMagicWand } from "react-icons/im";
import { SlCamera } from "react-icons/sl";

const Section4 = () => {
  return (
    <div>
      <section className="dream bg-light">
        <div className="container flow-content split">
          <div className="dream__text">
            <h2 className="section-heading">We Make Dreams Come True!</h2>

            <p>
              We don’t believe in one-size-fits-all. We work closely with you to
              bring your vision to life. Every element is thoughtfully planned
              to create a balanced, heartfelt celebration — one that feels
              natural, genuine, and truly your own.
            </p>
            <button className="primary-btn">
              <span className="arrow__icon">
                <BsArrowRight />
              </span>
              <span>Learn More</span>
            </button>
          </div>
          <div className="dream__lists split">
            <section className="split">
              <div className="dream__listItem">
                <i className="icon-box">
                  <ImMagicWand />
                </i>
                <h3>Decoration</h3>
                <p>
                  Stylish, theme-based, and tailored we bring your vision to
                  life with beautiful setups.
                </p>
              </div>
              <div className="dream__listItem">
                <i className="icon-box">
                  <GiForkKnifeSpoon />
                </i>

                <h3>Entertainment & Activities</h3>

                <p>
                  From playful experiences for kids to engaging entertainment
                  for all.
                </p>
              </div>
            </section>
            <section className="split">
              <div className="dream__listItem">
                <i className="icon-box">
                  <SlCamera />
                </i>
                <h3>Photography</h3>

                <p>
                  Professional photography that captures every smile, sparkle,
                  and special moment.
                </p>
              </div>
              <div className="dream__listItem">
                <i className="icon-box">
                  <CiMicrophoneOn />
                </i>
                <h3>Anchor & DJ Services</h3>

                <p>
                  Keep the energy high with engaging hosts and custom playlists.
                </p>
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Section4;
